import request from '../utils/request';

export const testData = () => {
    return request({
        url: '/account/oauthAccount',
        method: 'get'
    })
};

export const getMenu = () => {
    let user = localStorage.getItem("ms_userCd");
    return request({
        'url': `/function?user=${user}&type=menu`,
        method: 'get'
    })
};

export const getFuns = () => {
    let user = localStorage.getItem("ms_userCd");
    return request({
        'url': `/function?user=${user}&type=function`,
        method: 'get'
    })
}
